module.exports = __webpack_public_path__ + "media/fonts/Matter-Bold-cf5ffb28d8b1802acdd2aba091e48c5e.ttf";